import { combineReducers } from "@reduxjs/toolkit";
import treeMapSlice from "./treeMapSlice";

const rootReducer = combineReducers({
  treeMap: treeMapSlice,
});

export default rootReducer;
